module.exports = __webpack_public_path__ + "static/img/蒙版组 31.138c526.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/蒙版组 31.png
// module id = 6rcz
// module chunks = 1